'use strict';

/*global blockElement*/
/*global unBlockElement*/
/*global services*/
/*global initialize*/
function CatalogInfoPanel(containerID) {
    this.containerID = containerID;
    this.$container = null;

    this.init();
}

CatalogInfoPanel.prototype = $.extend({}, {
    construtor: 'CatalogInfoPanel',

    //**************************************************************************

    registerCallbacks: function registerCallbacks() {
        var _this = this;

        _this.$container.find('.date').off('click');
        _this.$container.find('.date').on('click', function dateClickClb() {
            _this.setFilterDate($(this).data('date'));
            _this.clearFilterParams();

            return false;
        });

        _this.$container.find('.param-value').off('click');
        _this.$container.find('.param-value').on('click', function paramValueClickClb() {
            var $row = $(this).closest('.param-row');
            var $cell = $(this).prop('tagName').toLowerCase() === 'td' ? $(this) : $(this).closest('td');

            _this.setFilterDate(_this.$container.find('table tr th:eq(' + $cell.index() +  ')').data('date'));
            _this.setFilterParam($row.data('param_id'), $row.data('value_id'));

            return false;
        });

        _this.$container.find('.param-title').off('click');
        _this.$container.find('.param-title').on('click', function paramTitleClickClb() {
            var $row = $(this).closest('.param-row');

            _this.setFilterParam($row.data('param_id'), $row.data('value_id'));
            _this.clearFilterDate();

            return false;
        });

        return _this;
    },

    setFilterDate: function setFilterDate(date) {
        if (services.has('catalogFilter')) {
            services.get('catalogFilter').setFilterDateFrom(date);
        }
    },

    setFilterParam: function setFilterParam(paramID, valueID) {
        if (services.has('catalogFilter')) {
            services.get('catalogFilter').setFilterParam(paramID, valueID);
        }
    },

    clearFilterDate: function clearFilterDate() {
        if (services.has('catalogFilter')) {
            services.get('catalogFilter').clearFilterDate();
        }
    },

    clearFilterParams: function clearFilterParams() {
        if (services.has('catalogFilter')) {
            services.get('catalogFilter').clearFilterParams();
        }
    },

    loadInfoPanel: function loadInfoPanel($form) {
        var _this = this;

        blockElement(_this.$container);
        $.postCORS(services.get('configurations').param('DomainURL') + '/?action=catalog&method=js_load_catalog_info_panel', $form ? $form.serialize() : {}, function loadInfoPanelClb(res) {
            unBlockElement(_this.$container);
            try {
                res = JSON.parse(res);
                if(res.msg === 'SUCCESS') {
                    _this.$container.html(res.data.html);
                    _this.registerCallbacks();

                    initialize(_this.$container);
                } else {
                    services.get('development').viewSiteErrorMsg(res);
                }
            } catch(e) {
                services.get('development').viewSiteErrorMsg(res, e);
            }
        });
    },

    //**************************************************************************

    init: function init() {
        var _this = this;

        _this.$container = $('#' + _this.containerID);
        _this.loadInfoPanel($('#catalog .catalog-filter-form'));

        return _this;
    }
});
